{
  "level": "sub01a",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:sub01a",
    "objects": "AREAS.E3:sub01a.e3",
    "mesh": "TREES.E3:sub01a.e3"
  },
  "spawn_point": {
    "position": [
      -1971.3787323389297,
      361.3434823843149,
      -355.6484069824219
    ],
    "facing_rad": 0.0,
    "look_point": [
      -1971.3787323389297,
      461.3434823843149,
      -355.6484069824219
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -2581.0,
      241.19454956054688,
      -379.6484069824219
    ],
    "bbox_max": [
      372.53997802734375,
      465.0,
      -130.9993896484375
    ],
    "vertex_count": 156,
    "vertices": [
      [
        -2445.0,
        465.0,
        -153.30496215820312
      ],
      [
        -2465.0,
        465.0,
        -154.57081604003906
      ],
      [
        -2465.0,
        458.4140930175781,
        -169.6226043701172
      ],
      [
        -2445.0,
        457.8602294921875,
        -169.6226043701172
      ],
      [
        -2445.0,
        457.8602294921875,
        -169.6226043701172
      ],
      [
        -2445.0,
        465.0,
        -153.30496215820312
      ],
      [
        -2465.0,
        465.0,
        -154.57081604003906
      ],
      [
        -2465.0,
        458.4140930175781,
        -169.6226043701172
      ],
      [
        226.1934814453125,
        266.44744873046875,
        -379.6484069824219
      ],
      [
        263.3448486328125,
        265.0264587402344,
        -379.6484069824219
      ],
      [
        263.3449401855469,
        265.02642822265625,
        -379.6484069824219
      ],
      [
        321.81439208984375,
        258.3407287597656,
        -369.62261962890625
      ],
      [
        321.8144836425781,
        258.3406982421875,
        -369.62261962890625
      ],
      [
        372.18310546875,
        249.3143310546875,
        -353.6243896484375
      ],
      [
        372.5399475097656,
        242.20077514648438,
        -337.6260986328125
      ],
      [
        321.9599609375,
        241.19454956054688,
        -330.9993896484375
      ],
      [
        372.18316650390625,
        249.31430053710938,
        -353.6243896484375
      ],
      [
        372.53997802734375,
        242.20077514648438,
        -337.6260986328125
      ],
      [
        238.3513641357422,
        272.97894287109375,
        -379.6484069824219
      ],
      [
        313.8619689941406,
        259.25006103515625,
        -370.9862365722656
      ],
      [
        238.3513641357422,
        272.97894287109375,
        -379.6484069824219
      ],
      [
        -2455.262939453125,
        465.0,
        -153.95452880859375
      ],
      [
        -2465.0,
        465.0,
        -151.90464782714844
      ],
      [
        -2445.0,
        452.0,
        -151.0772705078125
      ],
      [
        -2445.0,
        463.94866943359375,
        -155.7077178955078
      ],
      [
        -2465.0,
        465.0,
        -151.90464782714844
      ],
      [
        -2465.0,
        459.111328125,
        -149.62261962890625
      ],
      [
        -2465.0,
        459.11138916015625,
        -149.62261962890625
      ],
      [
        -2465.0,
        452.0,
        -146.8667449951172
      ],
      [
        -2451.90966796875,
        452.0,
        -149.62261962890625
      ],
      [
        -2445.447021484375,
        450.5034484863281,
        -150.40322875976562
      ],
      [
        -2445.0,
        452.0,
        -151.0772705078125
      ],
      [
        -2445.447021484375,
        450.5034484863281,
        -150.40322875976562
      ],
      [
        -1541.128173828125,
        318.0,
        -302.6517333984375
      ],
      [
        -1541.509521484375,
        359.099853515625,
        -318.56976318359375
      ],
      [
        -2524.348876953125,
        375.17657470703125,
        -148.39907836914062
      ],
      [
        -2424.117431640625,
        363.57373046875,
        -142.9824981689453
      ],
      [
        -2459.580322265625,
        394.9340515136719,
        -157.62255859375
      ],
      [
        -2449.580322265625,
        394.9340515136719,
        -157.62255859375
      ],
      [
        -2465.0,
        455.03131103515625,
        -148.0414581298828
      ],
      [
        -2465.0,
        452.0,
        -157.62255859375
      ],
      [
        -2445.0,
        452.0,
        -157.62255859375
      ],
      [
        -2445.0,
        452.0,
        -157.62255859375
      ],
      [
        -2445.0,
        463.11083984375,
        -157.62255859375
      ],
      [
        -2465.0,
        463.6647033691406,
        -157.62255859375
      ],
      [
        -2465.0,
        452.0,
        -157.62255859375
      ],
      [
        -2449.580322265625,
        394.9340515136719,
        -157.62255859375
      ],
      [
        -2449.580322265625,
        420.6392517089844,
        -169.62261962890625
      ],
      [
        -2449.580322265625,
        452.0,
        -169.6226043701172
      ],
      [
        -2449.580322265625,
        452.0,
        -169.6226043701172
      ],
      [
        -2449.580322265625,
        457.987060546875,
        -169.6226043701172
      ],
      [
        -2459.580322265625,
        420.6392517089844,
        -169.62261962890625
      ],
      [
        -2459.580322265625,
        394.9340515136719,
        -157.62255859375
      ],
      [
        -2459.580322265625,
        452.0,
        -169.6226043701172
      ],
      [
        -2459.580322265625,
        452.0,
        -169.6226043701172
      ],
      [
        -2459.580322265625,
        458.2640075683594,
        -169.6226043701172
      ],
      [
        -2449.580322265625,
        420.6392517089844,
        -169.62261962890625
      ],
      [
        -2459.580322265625,
        420.6392517089844,
        -169.62261962890625
      ],
      [
        -2428.816162109375,
        375.662841796875,
        -169.62261962890625
      ],
      [
        -2449.580322265625,
        375.662841796875,
        -165.25123596191406
      ],
      [
        -2459.580322265625,
        375.662841796875,
        -163.14598083496094
      ],
      [
        -2524.348876953125,
        375.662841796875,
        -149.51046752929688
      ],
      [
        -2449.580322265625,
        377.5755310058594,
        -169.62261962890625
      ],
      [
        -2459.580322265625,
        378.4966735839844,
        -169.62261962890625
      ],
      [
        -2449.580322265625,
        375.662841796875,
        -165.25123596191406
      ],
      [
        -2449.580322265625,
        377.5755310058594,
        -169.62261962890625
      ],
      [
        -2459.580322265625,
        378.4966735839844,
        -169.62261962890625
      ],
      [
        -2459.580322265625,
        375.662841796875,
        -163.14598083496094
      ],
      [
        -2424.117431640625,
        363.57373046875,
        -142.9824981689453
      ],
      [
        -2424.117431640625,
        368.23004150390625,
        -153.6243896484375
      ],
      [
        -2424.117431640625,
        368.23004150390625,
        -153.6243896484375
      ],
      [
        -2424.117431640625,
        375.2300109863281,
        -169.62261962890625
      ],
      [
        -2428.816162109375,
        375.662841796875,
        -169.62261962890625
      ],
      [
        -2424.117431640625,
        375.2300109863281,
        -169.62261962890625
      ],
      [
        -2524.348876953125,
        375.662841796875,
        -149.51046752929688
      ],
      [
        -2524.348876953125,
        375.17657470703125,
        -148.39907836914062
      ],
      [
        -1541.128173828125,
        318.0,
        -302.6517333984375
      ],
      [
        -1642.04833984375,
        310.900146484375,
        -297.4036865234375
      ],
      [
        -1642.22119140625,
        352.099853515625,
        -313.36553955078125
      ],
      [
        -1541.5093994140625,
        359.099853515625,
        -318.56976318359375
      ],
      [
        -2406.760986328125,
        340.181640625,
        -179.64840698242188
      ],
      [
        -2524.348876953125,
        375.662841796875,
        -149.8011016845703
      ],
      [
        -2522.96826171875,
        375.662841796875,
        -149.8011016845703
      ],
      [
        -2524.348876953125,
        375.662841796875,
        -149.8011016845703
      ],
      [
        -2524.348876953125,
        371.11785888671875,
        -153.6243896484375
      ],
      [
        -2524.348876953125,
        371.11785888671875,
        -153.6243896484375
      ],
      [
        -2424.117431640625,
        369.0069885253906,
        -155.4001007080078
      ],
      [
        -2519.661865234375,
        329.78173828125,
        -179.64840698242188
      ],
      [
        -2406.760986328125,
        340.181640625,
        -179.64840698242188
      ],
      [
        -2476.9833984375,
        352.099853515625,
        -137.6260986328125
      ],
      [
        -2581.0,
        343.9074401855469,
        -134.4512939453125
      ],
      [
        -2524.348876953125,
        363.7252502441406,
        -143.05322265625
      ],
      [
        -2425.426513671875,
        363.7252502441406,
        -143.05323791503906
      ],
      [
        -2524.348876953125,
        359.14666748046875,
        -153.51742553710938
      ],
      [
        -2524.348876953125,
        363.7252502441406,
        -143.05322265625
      ],
      [
        -2424.117431640625,
        359.14666748046875,
        -153.51742553710938
      ],
      [
        -2424.117431640625,
        363.66497802734375,
        -143.19102478027344
      ],
      [
        -2424.117431640625,
        354.5347595214844,
        -143.1909637451172
      ],
      [
        -2476.983642578125,
        352.099853515625,
        -137.6260986328125
      ],
      [
        -2424.117431640625,
        356.1436462402344,
        -139.51388549804688
      ],
      [
        -2424.117431640625,
        356.1436462402344,
        -139.51388549804688
      ],
      [
        -2424.117431640625,
        354.551025390625,
        -143.15374755859375
      ],
      [
        -2581.0,
        325.66448974609375,
        -176.14480590820312
      ],
      [
        -2519.661376953125,
        329.78173828125,
        -179.64840698242188
      ],
      [
        -2581.0,
        343.9074401855469,
        -134.4512939453125
      ],
      [
        -2581.0,
        325.66455078125,
        -176.14483642578125
      ],
      [
        -1642.04833984375,
        310.900146484375,
        -297.4036865234375
      ],
      [
        -1713.349365234375,
        318.0,
        -298.39117431640625
      ],
      [
        -2476.9833984375,
        318.0,
        -137.6260986328125
      ],
      [
        -2403.48046875,
        329.78173828125,
        -179.64840698242188
      ],
      [
        -2581.0,
        326.28497314453125,
        -134.3965606689453
      ],
      [
        -2476.9833984375,
        318.0,
        -137.6260986328125
      ],
      [
        -2403.480712890625,
        329.78173828125,
        -179.64840698242188
      ],
      [
        -2461.159912109375,
        335.1706848144531,
        -179.64840698242188
      ],
      [
        -2581.0,
        335.1706848144531,
        -154.41888427734375
      ],
      [
        -2581.0,
        326.28497314453125,
        -134.3965606689453
      ],
      [
        -1721.044921875,
        340.181640625,
        -306.7968444824219
      ],
      [
        -1642.2210693359375,
        352.099853515625,
        -313.36553955078125
      ],
      [
        -2576.787353515625,
        335.0,
        -130.9993896484375
      ],
      [
        -2366.555419921875,
        329.78173828125,
        -179.64840698242188
      ],
      [
        -2386.747314453125,
        327.2696838378906,
        -177.51075744628906
      ],
      [
        -2366.5556640625,
        329.78173828125,
        -179.64840698242188
      ],
      [
        -2581.0,
        327.2696838378906,
        -136.61541748046875
      ],
      [
        -2581.0,
        333.03533935546875,
        -131.76522827148438
      ],
      [
        -2576.78759765625,
        335.0,
        -130.9993896484375
      ],
      [
        -2581.0,
        333.03546142578125,
        -131.7651824951172
      ],
      [
        -1713.349365234375,
        318.0,
        -298.39117431640625
      ],
      [
        -1742.7379150390625,
        329.78173828125,
        -302.22991943359375
      ],
      [
        -2576.89111328125,
        334.9517517089844,
        -131.01820373535156
      ],
      [
        -2345.8974609375,
        334.95172119140625,
        -179.64840698242188
      ],
      [
        -1742.73779296875,
        329.78173828125,
        -302.22991943359375
      ],
      [
        -1721.044921875,
        340.181640625,
        -306.7968444824219
      ],
      [
        -2556.08251953125,
        335.0,
        -130.9993896484375
      ],
      [
        -2546.4208984375,
        329.78173828125,
        -133.03350830078125
      ],
      [
        -2546.54443359375,
        340.181640625,
        -133.00743103027344
      ],
      [
        -2556.082763671875,
        335.0,
        -130.9993896484375
      ],
      [
        -1586.85205078125,
        355.94830322265625,
        -316.2267150878906
      ],
      [
        307.9207458496094,
        262.7614440917969,
        -337.6260986328125
      ],
      [
        -1532.589599609375,
        310.900146484375,
        -320.4476318359375
      ],
      [
        -1621.3636474609375,
        318.0,
        -317.756591796875
      ],
      [
        -1532.589599609375,
        310.900146484375,
        -320.4476318359375
      ],
      [
        307.9207763671875,
        262.7614440917969,
        -337.6260986328125
      ],
      [
        372.3887023925781,
        245.21694946289062,
        -344.40948486328125
      ],
      [
        -1621.363525390625,
        318.0,
        -317.756591796875
      ],
      [
        -1690.51806640625,
        329.78173828125,
        -313.22357177734375
      ],
      [
        -1690.5179443359375,
        329.78173828125,
        -313.22357177734375
      ],
      [
        -1709.695556640625,
        340.181640625,
        -309.1861877441406
      ],
      [
        -1709.695556640625,
        340.181640625,
        -309.1861877441406
      ],
      [
        -1704.28369140625,
        342.7159423828125,
        -308.1936340332031
      ],
      [
        -1587.30615234375,
        318.0,
        -324.9266052246094
      ],
      [
        365.88409423828125,
        251.31854248046875,
        -353.6243896484375
      ],
      [
        321.78216552734375,
        258.9891662597656,
        -339.0845947265625
      ],
      [
        365.88427734375,
        251.31849670410156,
        -353.6243896484375
      ],
      [
        365.92694091796875,
        250.4354705810547,
        -355.6114807128906
      ],
      [
        -1587.3060302734375,
        318.0,
        -324.9266052246094
      ],
      [
        -1657.63525390625,
        324.1795654296875,
        -315.3789978027344
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 169.6226043701172,
      "bbox_min": [
        -2465.0,
        457.8602294921875,
        -169.6226043701172
      ],
      "bbox_max": [
        -2445.0,
        465.0,
        -153.30496215820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2445.0,
      "bbox_min": [
        -2465.0,
        457.8602294921875,
        -169.6226043701172
      ],
      "bbox_max": [
        -2445.0,
        465.0,
        -153.30496215820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 2465.0,
      "bbox_min": [
        -2465.0,
        458.4140930175781,
        -169.6226043701172
      ],
      "bbox_max": [
        -2465.0,
        465.0,
        -154.57081604003906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2798520028591156,
        -0.8795349597930908,
        0.38483911752700806
      ],
      "plane_d": 459.52532958984375,
      "bbox_min": [
        321.8144836425781,
        -70.0,
        -369.62261962890625
      ],
      "bbox_max": [
        1300.0,
        258.3406982421875,
        -330.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11422112584114075,
        -0.358980655670166,
        -0.9263295531272888
      ],
      "plane_d": -183.25570678710938,
      "bbox_min": [
        321.9599609375,
        -70.0,
        -353.6243896484375
      ],
      "bbox_max": [
        1300.0,
        249.31430053710938,
        -330.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27985215187072754,
        -0.8795353770256042,
        -0.3848378360271454
      ],
      "plane_d": 187.34896850585938,
      "bbox_min": [
        372.18316650390625,
        -52.900146484375,
        -353.6243896484375
      ],
      "bbox_max": [
        1300.0,
        249.31430053710938,
        -337.6260986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.030450282618403435,
        0.6477721929550171,
        0.7612252831459045
      ],
      "plane_d": 104.91192626953125,
      "bbox_min": [
        -2581.0,
        241.19454956054688,
        -379.6484069824219
      ],
      "bbox_max": [
        372.53997802734375,
        465.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2445.0,
      "bbox_min": [
        -2465.0,
        450.5034484863281,
        -155.7077178955078
      ],
      "bbox_max": [
        -2445.0,
        465.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2465.0,
      "bbox_min": [
        -2465.0,
        450.5034484863281,
        -151.90464782714844
      ],
      "bbox_max": [
        -2445.0,
        465.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.462472528219223,
        -0.886633574962616
      ],
      "plane_d": -341.697998046875,
      "bbox_min": [
        -2451.90966796875,
        450.5034484863281,
        -151.0772705078125
      ],
      "bbox_max": [
        -2445.0,
        452.0,
        -149.62261962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9581836462020874,
        0.2861540615558624,
        0.0
      ],
      "plane_d": -2472.1005859375,
      "bbox_min": [
        -2445.447021484375,
        450.5034484863281,
        -151.0772705078125
      ],
      "bbox_max": [
        -2445.0,
        452.0,
        -149.62261962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -157.62255859375,
      "bbox_min": [
        -2465.0,
        394.9340515136719,
        -169.62261962890625
      ],
      "bbox_max": [
        -2445.0,
        465.0,
        -146.8667449951172
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2465.0,
      "bbox_min": [
        -2465.0,
        452.0,
        -149.62261962890625
      ],
      "bbox_max": [
        -2465.0,
        455.03131103515625,
        -146.8667449951172
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2445.0,
      "bbox_min": [
        -2465.0,
        452.0,
        -157.62255859375
      ],
      "bbox_max": [
        -2445.0,
        465.0,
        -148.0414581298828
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 2465.0,
      "bbox_min": [
        -2465.0,
        452.0,
        -157.62255859375
      ],
      "bbox_max": [
        -2455.262939453125,
        465.0,
        -148.0414581298828
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 465.0,
      "bbox_min": [
        -2465.0,
        465.0,
        -154.57081604003906
      ],
      "bbox_max": [
        -2455.262939453125,
        465.0,
        -151.90464782714844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9581836462020874,
        0.2861540615558624,
        0.0
      ],
      "plane_d": -2472.1005859375,
      "bbox_min": [
        -2449.580322265625,
        436.662841796875,
        -169.62261962890625
      ],
      "bbox_max": [
        -2445.0,
        463.11083984375,
        -157.62255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9428636431694031,
        0.33317887783050537,
        -0.0
      ],
      "plane_d": 2173.56201171875,
      "bbox_min": [
        -2465.0,
        436.662841796875,
        -169.62261962890625
      ],
      "bbox_max": [
        -2459.580322265625,
        463.6647033691406,
        -157.62255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2449.580322265625,
      "bbox_min": [
        -2459.580322265625,
        375.662841796875,
        -169.62261962890625
      ],
      "bbox_max": [
        -2449.580322265625,
        420.6392517089844,
        -157.62255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2459.580322265625,
      "bbox_min": [
        -2459.580322265625,
        375.662841796875,
        -169.62261962890625
      ],
      "bbox_max": [
        -2449.580322265625,
        420.6392517089844,
        -157.62255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -157.62255859375,
      "bbox_min": [
        -2459.580322265625,
        375.662841796875,
        -157.62255859375
      ],
      "bbox_max": [
        -2449.580322265625,
        394.9340515136719,
        -157.62255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2424.117431640625,
      "bbox_min": [
        -2524.348876953125,
        363.57373046875,
        -169.62261962890625
      ],
      "bbox_max": [
        -2424.117431640625,
        375.662841796875,
        -142.9824981689453
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 169.62261962890625,
      "bbox_min": [
        -2524.348876953125,
        375.17657470703125,
        -169.62261962890625
      ],
      "bbox_max": [
        -2424.117431640625,
        375.662841796875,
        -148.39907836914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 2524.348876953125,
      "bbox_min": [
        -2524.348876953125,
        375.17657470703125,
        -149.51046752929688
      ],
      "bbox_max": [
        -2524.348876953125,
        375.662841796875,
        -148.39907836914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 375.662841796875,
      "bbox_min": [
        -2524.348876953125,
        352.099853515625,
        -169.62261962890625
      ],
      "bbox_max": [
        -2424.117431640625,
        378.4966735839844,
        -149.8011016845703
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2459.580322265625,
      "bbox_min": [
        -2459.580322265625,
        375.662841796875,
        -169.62261962890625
      ],
      "bbox_max": [
        -2449.580322265625,
        378.4966735839844,
        -163.14598083496094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2449.580322265625,
      "bbox_min": [
        -2449.580322265625,
        375.662841796875,
        -169.62261962890625
      ],
      "bbox_max": [
        -2449.580322265625,
        377.5755310058594,
        -165.25123596191406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2424.117431640625,
      "bbox_min": [
        -2424.117431640625,
        352.099853515625,
        -169.62261962890625
      ],
      "bbox_max": [
        -2424.117431640625,
        375.2300109863281,
        -155.4001007080078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2424.117431640625,
      "bbox_min": [
        -2524.348876953125,
        352.099853515625,
        -169.62261962890625
      ],
      "bbox_max": [
        -2424.117431640625,
        375.662841796875,
        -143.19102478027344
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 375.662841796875,
      "bbox_min": [
        -2524.348876953125,
        375.662841796875,
        -149.8011016845703
      ],
      "bbox_max": [
        -2522.96826171875,
        375.662841796875,
        -149.51046752929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.42300987243652344,
        -0.9061251878738403
      ],
      "plane_d": 24.2352294921875,
      "bbox_min": [
        -2524.348876953125,
        352.099853515625,
        -153.51742553710938
      ],
      "bbox_max": [
        -2424.117431640625,
        363.7252502441406,
        -137.6260986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 2524.348876953125,
      "bbox_min": [
        -2524.348876953125,
        352.099853515625,
        -153.51742553710938
      ],
      "bbox_max": [
        -2424.117431640625,
        363.7252502441406,
        -137.6260986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2424.117431640625,
      "bbox_min": [
        -2424.117431640625,
        354.551025390625,
        -153.51742553710938
      ],
      "bbox_max": [
        -2424.117431640625,
        363.66497802734375,
        -139.51388549804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6480727195739746,
        0.7615784406661987
      ],
      "plane_d": -76.90618896484375,
      "bbox_min": [
        -2581.0,
        325.66448974609375,
        -179.64840698242188
      ],
      "bbox_max": [
        -2519.661376953125,
        359.099853515625,
        -134.4512939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2581.0,
      "bbox_min": [
        -2581.0,
        325.66455078125,
        -179.64840698242188
      ],
      "bbox_max": [
        -2581.0,
        359.099853515625,
        -134.4512939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.3631887435913086,
        -0.9317156672477722
      ],
      "plane_d": -243.722412109375,
      "bbox_min": [
        -2581.0,
        310.900146484375,
        -179.64840698242188
      ],
      "bbox_max": [
        -2403.480712890625,
        335.1706848144531,
        -134.3965606689453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 179.64840698242188,
      "bbox_min": [
        -2581.0,
        310.900146484375,
        -179.64840698242188
      ],
      "bbox_max": [
        -2403.480712890625,
        335.1706848144531,
        -134.3965606689453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2581.0,
      "bbox_min": [
        -2581.0,
        310.900146484375,
        -176.14483642578125
      ],
      "bbox_max": [
        -2581.0,
        335.1706848144531,
        -134.3965606689453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6480727195739746,
        0.7615784406661987
      ],
      "plane_d": -76.90618896484375,
      "bbox_min": [
        -2581.0,
        327.2696838378906,
        -179.64840698242188
      ],
      "bbox_max": [
        -2366.5556640625,
        343.9074401855469,
        -130.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2581.0,
      "bbox_min": [
        -2581.0,
        327.2696838378906,
        -154.41888427734375
      ],
      "bbox_max": [
        -2576.78759765625,
        343.9074401855469,
        -130.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.3631887435913086,
        -0.9317156672477722
      ],
      "plane_d": -243.722412109375,
      "bbox_min": [
        -2581.0,
        333.03546142578125,
        -131.7651824951172
      ],
      "bbox_max": [
        -2576.78759765625,
        335.0,
        -130.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.3631887435913086,
        -0.9317156672477722
      ],
      "plane_d": -243.722412109375,
      "bbox_min": [
        -2581.0,
        318.0,
        -179.64840698242188
      ],
      "bbox_max": [
        -2325.0,
        334.9517517089844,
        -131.01820373535156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6480727195739746,
        0.7615784406661987
      ],
      "plane_d": -76.90618896484375,
      "bbox_min": [
        -2581.0,
        318.0,
        -179.64840698242188
      ],
      "bbox_max": [
        -2325.0,
        334.95172119140625,
        -131.76522827148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 179.64840698242188,
      "bbox_min": [
        -2581.0,
        326.28497314453125,
        -179.64840698242188
      ],
      "bbox_max": [
        -2325.0,
        334.95172119140625,
        -131.76522827148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2581.0,
      "bbox_min": [
        -2581.0,
        326.28497314453125,
        -136.61541748046875
      ],
      "bbox_max": [
        -2581.0,
        333.03533935546875,
        -131.76522827148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.3631887435913086,
        -0.9317156672477722
      ],
      "plane_d": -243.722412109375,
      "bbox_min": [
        -2576.89111328125,
        329.78173828125,
        -179.64840698242188
      ],
      "bbox_max": [
        -2325.0,
        340.181640625,
        -130.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.3613455295562744,
        -0.9324319958686829
      ],
      "plane_d": -1.0972747802734375,
      "bbox_min": [
        -2576.787353515625,
        329.78173828125,
        -179.64840698242188
      ],
      "bbox_max": [
        -2325.0,
        340.181640625,
        -130.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9161416292190552,
        -0.40085476636886597
      ],
      "plane_d": 267.4052734375,
      "bbox_min": [
        -2476.983642578125,
        352.099853515625,
        -153.6243896484375
      ],
      "bbox_max": [
        -2325.0,
        359.099853515625,
        -137.6260986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.42300987243652344,
        -0.9061251878738403
      ],
      "plane_d": 24.2352294921875,
      "bbox_min": [
        -2476.983642578125,
        352.099853515625,
        -143.15374755859375
      ],
      "bbox_max": [
        -2424.117431640625,
        356.1436462402344,
        -137.6260986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2424.117431640625,
      "bbox_min": [
        -2424.117431640625,
        352.099853515625,
        -143.15374755859375
      ],
      "bbox_max": [
        -2424.117431640625,
        356.1436462402344,
        -137.6260986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03495161607861519,
        -0.9155818819999695,
        -0.4006098806858063
      ],
      "plane_d": 143.75323486328125,
      "bbox_min": [
        -1742.7379150390625,
        241.19454956054688,
        -379.6484069824219
      ],
      "bbox_max": [
        372.53997802734375,
        359.099853515625,
        -297.4036865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08409183472394943,
        -0.9128960967063904,
        0.39943620562553406
      ],
      "plane_d": 584.697509765625,
      "bbox_min": [
        -1586.85205078125,
        352.099853515625,
        -333.6243896484375
      ],
      "bbox_max": [
        -1470.0,
        359.099853515625,
        -316.2267150878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11422112584114075,
        -0.358980655670166,
        -0.9263295531272888
      ],
      "plane_d": -183.25570678710938,
      "bbox_min": [
        -1742.7379150390625,
        241.19454956054688,
        -344.40948486328125
      ],
      "bbox_max": [
        372.53997802734375,
        342.7159423828125,
        -297.4036865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08508794754743576,
        0.910718560218811,
        0.4041677415370941
      ],
      "plane_d": -23.2230224609375,
      "bbox_min": [
        -1742.7379150390625,
        242.20077514648438,
        -344.40948486328125
      ],
      "bbox_max": [
        372.53997802734375,
        342.7159423828125,
        -297.4036865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1583103984594345,
        0.6399000883102417,
        0.7519744038581848
      ],
      "plane_d": 292.1353454589844,
      "bbox_min": [
        -1742.7379150390625,
        318.0,
        -317.756591796875
      ],
      "bbox_max": [
        -1470.0,
        342.7159423828125,
        -298.39117431640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19248270988464355,
        0.35639724135398865,
        -0.9142928719520569
      ],
      "plane_d": -686.6871948242188,
      "bbox_min": [
        -1742.73779296875,
        318.0,
        -317.6260986328125
      ],
      "bbox_max": [
        -1470.0,
        342.7159423828125,
        -302.22991943359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20601050555706024,
        -0.0,
        0.9785498976707458
      ],
      "plane_d": 654.7693481445312,
      "bbox_min": [
        -1742.73779296875,
        329.78173828125,
        -313.22357177734375
      ],
      "bbox_max": [
        -1690.5179443359375,
        342.7159423828125,
        -302.22991943359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15905366837978363,
        -0.6355425119400024,
        0.7555049061775208
      ],
      "plane_d": 721.7249145507812,
      "bbox_min": [
        -1721.044921875,
        340.181640625,
        -309.1861877441406
      ],
      "bbox_max": [
        -1704.28369140625,
        342.7159423828125,
        -306.7968444824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08508794754743576,
        0.910718560218811,
        0.4041677415370941
      ],
      "plane_d": -23.2230224609375,
      "bbox_min": [
        -1657.63525390625,
        245.21694946289062,
        -355.6114807128906
      ],
      "bbox_max": [
        372.3887023925781,
        324.1795654296875,
        -315.3789978027344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1583103984594345,
        0.6399000883102417,
        0.7519744038581848
      ],
      "plane_d": 292.1353454589844,
      "bbox_min": [
        -1657.63525390625,
        318.0,
        -324.9266052246094
      ],
      "bbox_max": [
        -1587.3060302734375,
        324.1795654296875,
        -315.3789978027344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11422112584114075,
        -0.358980655670166,
        -0.9263295531272888
      ],
      "plane_d": -183.25570678710938,
      "bbox_min": [
        200.0,
        258.3407287597656,
        -379.6484069824219
      ],
      "bbox_max": [
        321.81439208984375,
        297.099853515625,
        -330.9993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2006595879793167,
        -0.6306444406509399,
        0.7496822476387024
      ],
      "plane_d": 504.5957946777344,
      "bbox_min": [
        200.0,
        258.3407287597656,
        -379.6484069824219
      ],
      "bbox_max": [
        321.81439208984375,
        297.099853515625,
        -369.62261962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": 379.64837646484375,
      "bbox_min": [
        200.0,
        272.97894287109375,
        -379.6484069824219
      ],
      "bbox_max": [
        238.3513641357422,
        285.181640625,
        -379.6484069824219
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}